import React, { useState, useEffect } from 'react';
import { v4 as uuidv4 } from "uuid";
import NavBar from "./components/NavBar/NavBar";
import News from "./components/News/News";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { router } from "./config/config";
import Search from "./components/Search/Search";
import Dashboard from "./components/Repoter/Dashboardrp/Dashboardrp";
import NewsList from "./components/Repoter/NewsList/NewsList";
import AddNews from "./components/Repoter/AddNews/AddNews";
import ReporterRegistrationForm from "./components/ReporterRegistration/ReporterRegistrationForm";
import ReLoginpage from "./components/reporterlogin/ReLoginPage";
import Profile from "./components/Repoter/Profile/Profile";
import ProtectedRoute from "./ProtectedRoute"; // Import the ProtectedRoute component
import Dashboard_admin from "./components/Admin/Dashboardadmin/Dashboard_admin";
import Repotermanagement from "./components/Admin/Repoter_Management/Repotermanagement";
import AdminNewsManagement from "./components/Admin/AdminNewsManagement/AdminNewsManagement";
import ManageCategoriesAndItems from "./components/Admin/Scrollbar/ManageCategoriesAndItems";
import PriceManagement from "./components/Admin/Scrollbar/PriceManagement";
import AdsManagement from "./components/Admin/AdsManagement/AdsManagement";
import ViewsList from "./components/Admin/Views/ViewsList";
import EarningsManagement from "./components/Admin/EarningsManagement/EarningsManagement";
import NewsArticle from "./components/NewsArticle/NewsArticle";
import CategoryNews from "./components/News/CategoryNews";
import Login from "./components/reporterlogin/a/Login";
import EarningsPage from "./components/Repoter/Earnings/Earnings";
import PrivacyPolicy from "./components/Pages/PrivacyPolicy";
import TermsAndConditions from "./components/Pages/TermsAndConditions";
import PaymentPolicy from "./components/Pages/PaymentPolicy";
import Userterms from "./components/Pages/Userterms";
import GoverningLawAndJurisdiction from "./components/Pages/GoverningLawAndJurisdiction";
import EnquiryForm from "./components/Pages/EnquiryForm";
import AdLoginPage from "./components/Admin/Login/adLoginPage";
import AdminManagement from "./components/Admin/AdminManagement/AdminManagement";
import LocationTracker from "./components/Location/location";
import ForgotPassword from './components/reporterlogin/ForgotPassword';
import ChannelManager from './components/Admin/ChannelManager/ChannelManager';


function App() {
 
  const [district, setDistrict] = useState("");

  // Handle district updates from the LocationTracker component
  const handleDistrictUpdate = (newDistrict) => {
  setDistrict(newDistrict);
  };
  
  useEffect(() => {
  // If you want to perform any initial logic when the app starts (like fetching data based on district)
  }, [district]);


  return (
    <>
      <Router>

      <LocationTracker onDistrictUpdate={handleDistrictUpdate} />
       
        <Routes>
          {router.map((path) => (
            <Route
              exact
              key={uuidv4()}
              path={path.path}
              element={
                <News
                  key={path.key}
                  newscategory={path.category}
                  country={path.country}
                />
              }
            />
          ))}
         {/* Search Route */}
         <Route path="/search/:query" element={<Search />} />

{/* Public Routes */}
<Route path="/reporter/register" element={<ReporterRegistrationForm />} />
<Route path="/reporter/login" element={<Login />} />
<Route path="/reporter/forgot-password" element={<ForgotPassword />} />


{/* Protected Routes */}
{/* Reporter Routes */}
<Route
  path="/reporter/dashboard"
  element={<ProtectedRoute element={<Dashboard />} requiredRole="reporter" />}
/>
<Route
  path="/reporter/add-news"
  element={<ProtectedRoute element={<AddNews />} requiredRole="reporter" />}
/>
<Route
  path="/reporter/news-list"
  element={<ProtectedRoute element={<NewsList />} requiredRole="reporter" />}
/>
<Route
  path="/reporter/profile"
  element={<ProtectedRoute element={<Profile />} requiredRole="reporter" />}
/>
<Route
  path="/reporter/earnings"
  element={<ProtectedRoute element={<EarningsPage />} requiredRole="reporter" />}
/>


{/* Admin Routes */}
<Route
  path="/admin/login"
  element={<AdLoginPage />} // Login page does not need ProtectedRoute
/>
<Route
  path="/admin/dashboard"
  element={<ProtectedRoute element={<Dashboard_admin />} requiredRole="admin" />}
/>
<Route
  path="/admin/user/management"
  element={<ProtectedRoute element={<AdminManagement />} requiredRole="admin" />}
/>
<Route
  path="/admin/Repotermanagement"
  element={<ProtectedRoute element={<Repotermanagement />} requiredRole="admin" />}
/>
<Route
  path="/admin/AdminNewsManagement"
  element={<ProtectedRoute element={<AdminNewsManagement />} requiredRole="admin" />}
/>
<Route
  path="/admin/Runningbar/update"
  element={<ProtectedRoute element={<PriceManagement />} requiredRole="admin" />}
/>
<Route
  path="/admin/ads/management"
  element={<ProtectedRoute element={<AdsManagement />} requiredRole="admin" />}
/>
<Route
  path="/admin/views/management"
  element={<ProtectedRoute element={<ViewsList />} requiredRole="admin" />}
/>
<Route
  path="/admin/earnings/management"
  element={<ProtectedRoute element={<EarningsManagement />} requiredRole="admin" />}
/>

<Route
  path="/admin/channel/management"
  element={<ProtectedRoute element={<ChannelManager/>} requiredRole="admin" />}
/>


{/* Frontpage */}

<Route path="/news/:newsId" element={<NewsArticle />} />
<Route path="/" element={<News />} />

<Route path="/category/:category" element={<CategoryNews />} />



{/* footerpage */}
<Route path="/advertise" element={<EnquiryForm />} />  {/* Default route */}
<Route path="/privacy-policy" element={<PrivacyPolicy />} />
<Route path="/terms-and-conditions" element={<TermsAndConditions />} />
<Route path="/payment-policy" element={<PaymentPolicy />} />
<Route path="/user-terms" element={<Userterms />} />
<Route path="/governing-law-and-jurisdiction" element={<GoverningLawAndJurisdiction />} />  {/* New Route for Governing Law and Jurisdiction */}
</Routes>
      </Router>
    </>
  );
}

export default App;
